import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ProductLineWishlistComponent } from './product-line-wishlist.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { WishListModule } from '@spartacus/cart/wish-list'
import { DirectiveModule } from '../../directive.module'

@NgModule({
  declarations: [ProductLineWishlistComponent],
    imports: [
        CommonModule,
        WishListModule,
        NgbModule,
        MbI18nModule,
        DirectiveModule
    ],
  exports: [ProductLineWishlistComponent]
})
export class ProductLineWishlistModule { }
